"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Input = require("../form/Input");

var _Input2 = _interopRequireDefault(_Input);

var _Select = require("../form/Select");

var _Select2 = _interopRequireDefault(_Select);

var _Checkbox = require("../form/Checkbox");

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _RadioGroup = require("../form/RadioGroup");

var _RadioGroup2 = _interopRequireDefault(_RadioGroup);

var _SubmitButton = require("../form/SubmitButton");

var _SubmitButton2 = _interopRequireDefault(_SubmitButton);

var _Button = require("../form/Button");

var _Button2 = _interopRequireDefault(_Button);

var _reactRouter = require("react-router");

var _AdFormMap = require("../map/AdFormMap");

var _AdFormMap2 = _interopRequireDefault(_AdFormMap);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _LocationsUtil = require("../../utils/LocationsUtil");

var _reactDatepicker = require("react-datepicker");

var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import "react-datepicker/dist/react-datepicker.css";

var AdForm = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(AdForm, _Component);

  function AdForm(props) {
    (0, _classCallCheck3.default)(this, AdForm);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AdForm.__proto__ || (0, _getPrototypeOf2.default)(AdForm)).call(this, props));

    _this.handleAddressChange = function (address) {
      if (!address) {
        return;
      }
      var postal_area = _this.props.fields.postal_area;

      _this.getCoordinates(address, postal_area.value);
    };

    _this.handlePostalAreaChange = function (postalArea) {
      if (!postalArea) {
        return;
      }
      var address = _this.props.fields.address;

      _this.getCoordinates(address.value, postalArea);
    };

    _this.getCoordinates = function (address, postalArea) {
      var _this$props$fields = _this.props.fields,
          latitude = _this$props$fields.latitude,
          longitude = _this$props$fields.longitude;

      (0, _LocationsUtil.getCoordinatesForAddress)(address, postalArea).then(function (coordinates) {
        latitude.onChange(coordinates.lat());
        longitude.onChange(coordinates.lng());
      }).catch(console.error);
    };

    _this.onSubmit = function (values) {
      var isProjectAd = _this.props.isProjectAd;
      var _this$props = _this.props,
          project = _this$props.project,
          company = _this$props.company;
      // if private ad we save company_id else 0

      if (values.ad_visibility == "private_Ad") {
        values.ad_visibility = Number(company.id);
      } else {
        values.ad_visibility = Number(0);
      }

      values.soil_type_id = Number(values.soil_type_id);
      values.price = Number(values.price) || 0;
      values.soil_amount = Number(values.soil_amount);
      values.latitude = Number(values.latitude);
      values.longitude = Number(values.longitude);
      values.validity_duration = _this.state.startDate;
      values.delivery_start_date = _this.state.deliveryStartDate;
      values.delivery_end_date = _this.state.deliveryEndDate;

      if (isProjectAd) {
        values.project_id = project.project_id;
      } else {
        values.project_id = 0;
      }

      _this.props.submitAd(values);
    };

    _this.state = {
      startDate: (0, _moment2.default)().add(7, "days"),
      deliveryStartDate: (0, _moment2.default)(),
      deliveryEndDate: (0, _moment2.default)()
    };
    _this.handleStartDateChange = _this.handleStartDateChange.bind(_this);
    _this.handleDeliveryStartDateChange = _this.handleDeliveryStartDateChange.bind(_this);
    _this.handleDeliveryEndDateChange = _this.handleDeliveryEndDateChange.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(AdForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props = this.props,
          project = _props.project,
          user = _props.user,
          company = _props.company,
          isProjectAd = _props.isProjectAd,
          validUntil = _props.validUntil,
          resetForm = _props.resetForm,
          editing = _props.editing,
          deliveryStartDate = _props.deliveryStartDate,
          deliveryEndDate = _props.deliveryEndDate;

      if (editing) {
        this.setState({
          startDate: (0, _moment2.default)(validUntil),
          deliveryStartDate: (0, _moment2.default)(deliveryStartDate),
          deliveryEndDate: (0, _moment2.default)(deliveryEndDate)
        });
      }

      resetForm();
      var _props$fields = this.props.fields,
          contractor = _props$fields.contractor,
          contact_person_name = _props$fields.contact_person_name,
          contact_person_phone = _props$fields.contact_person_phone,
          contact_person_email = _props$fields.contact_person_email,
          construction_site_id = _props$fields.construction_site_id,
          builder = _props$fields.builder,
          address = _props$fields.address,
          postal_area = _props$fields.postal_area,
          postal_code = _props$fields.postal_code,
          project_id = _props$fields.project_id,
          activated = _props$fields.activated,
          validity_duration = _props$fields.validity_duration,
          delivery_end_date = _props$fields.delivery_end_date,
          delivery_start_date = _props$fields.delivery_start_date;


      if (isProjectAd) {
        //   contact_person_name.onChange(project.contact_person_name);
        //   contact_person_phone.onChange(String(project.contact_person_phone));
        //   contact_person_email.onChange(project.contact_person_email);
        //    contact_person_name.onChange(`${user.first_name} ${user.last_name}`);
        //    contact_person_phone.onChange(user.phone);
        //    contact_person_email.onChange(user.email);
        construction_site_id.onChange(String(project.construction_site_id)); // Työnumero
        builder.onChange(String(project.contractor));
        contractor.onChange(String(project.contractor));
        address.onChange(String(project.project_site_address));
        postal_area.onChange(String(project.project_postal_area));
        postal_code.onChange(String(project.project_postal_code));
        validity_duration.onChange(validUntil);
        delivery_start_date.onChange(deliveryStartDate);
        delivery_end_date.onChange(deliveryEndDate);

        activated.onChange(activated);
      } else {
        if (user) {
          construction_site_id.onChange(String("")); // Työnumero
          builder.onChange(String(""));
          contractor.onChange(String(""));
          address.onChange(String(""));
          postal_area.onChange(String(""));
          postal_code.onChange(String(""));

          contact_person_name.onChange(user.first_name + " " + user.last_name);
          contact_person_phone.onChange(user.phone);
          contact_person_email.onChange(user.email);
          delivery_start_date.onChange(deliveryStartDate);
          delivery_end_date.onChange(deliveryEndDate);
          if (company) {
            contractor.onChange("" + company.name);
          } else {
            contractor.onChange(user.first_name + " " + user.last_name);
          }
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props$fields2 = this.props.fields,
          construction_site_id = _props$fields2.construction_site_id,
          project_id = _props$fields2.project_id,
          builder = _props$fields2.builder,
          contractor = _props$fields2.contractor,
          latitude = _props$fields2.latitude,
          longitude = _props$fields2.longitude,
          address = _props$fields2.address,
          postal_area = _props$fields2.postal_area,
          postal_code = _props$fields2.postal_code,
          contact_person_name = _props$fields2.contact_person_name,
          contact_person_phone = _props$fields2.contact_person_phone,
          contact_person_email = _props$fields2.contact_person_email,
          soil_amount = _props$fields2.soil_amount,
          soil_type_id = _props$fields2.soil_type_id,
          soil_description = _props$fields2.soil_description,
          price = _props$fields2.price,
          delivery_time = _props$fields2.delivery_time,
          delivery_start_date = _props$fields2.delivery_start_date,
          delivery_end_date = _props$fields2.delivery_end_date,
          validity_duration = _props$fields2.validity_duration,
          notes = _props$fields2.notes,
          transfer_request = _props$fields2.transfer_request,
          activated = _props$fields2.activated,
          end_date = _props$fields2.end_date,
          ad_visibility = _props$fields2.ad_visibility,
          visibility = _props$fields2.visibility;
      var editing = this.props.editing;


      var isProjectAd = this.props.isProjectAd;

      return _react2.default.createElement(
        "form",
        {
          id: "createAd",
          className: "col col-xs-12",
          onSubmit: this.props.handleSubmit(this.onSubmit)
        },
        _react2.default.createElement(
          "div",
          { className: "row" },
          this.renderHeaderSection(),
          this.renderAdVisibilitySection()
        ),
        _react2.default.createElement(
          "h2",
          { className: "h4 form-title" },
          "Ty\xF6maatiedot"
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Input2.default, {
              id: "construction_site_id",
              type: "text",
              label: "Ty\xF6numero",
              subLabel: "(vapaaehtoinen)",
              fieldProps: construction_site_id
            })
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Input2.default, {
              id: "builder",
              type: "text",
              label: "Rakennuttaja",
              subLabel: "(vapaaehtoinen)",
              fieldProps: builder
            })
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Input2.default, {
              id: "contractor",
              type: "text",
              label: "Urakoitsija",
              fieldProps: contractor
            })
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Input2.default, {
              id: "address",
              type: "text",
              label: "Ty\xF6maan osoite",
              fieldProps: address,
              handleBlur: function handleBlur(event) {
                address.onBlur(event);
                _this2.handleAddressChange(event.target.value);
              }
            })
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Input2.default, {
              id: "postal_code",
              type: "text",
              label: "Postinumero",
              fieldProps: postal_code
            })
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Input2.default, {
              id: "postal_area",
              type: "text",
              label: "Paikkakunta",
              fieldProps: postal_area,
              handleBlur: function handleBlur(event) {
                postal_area.onBlur(event);
                _this2.handlePostalAreaChange(event.target.value);
              }
            })
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-12" },
            _react2.default.createElement(
              "span",
              null,
              "Tarkista, ett\xE4 osoitin on kartalla oikeassa paikassa! Voit siirt\xE4\xE4 osoittimen haluamaasi kohtaan kartalla."
            ),
            _react2.default.createElement(_AdFormMap2.default, {
              latitude: latitude.value,
              longitude: longitude.value,
              handleMarkerDrag: this.handleMarkerDrag.bind(this)
            }),
            _react2.default.createElement(_Input2.default, { id: "latitude", type: "hidden", fieldProps: latitude }),
            _react2.default.createElement(_Input2.default, { id: "longitude", type: "hidden", fieldProps: longitude })
          )
        ),
        _react2.default.createElement(
          "h2",
          { className: "h4 form-title" },
          "Yhteyshenkil\xF6"
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Input2.default, {
              id: "contact_person_name",
              type: "text",
              label: "Nimi",
              fieldProps: contact_person_name
            })
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6 button-row" },
            _react2.default.createElement(
              "button",
              {
                className: "button-small",
                onClick: this.clearContactInfo.bind(this)
              },
              "Tyhjenn\xE4 tiedot"
            ),
            _react2.default.createElement(
              "button",
              {
                className: "button-small",
                onClick: this.addContactInfo.bind(this)
              },
              "Lis\xE4\xE4 omat Tiedot"
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Input2.default, {
              id: "contact_person_phone",
              type: "text",
              label: "Puhelinnumero",
              fieldProps: contact_person_phone
            })
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Input2.default, {
              id: "contact_person_email",
              type: "text",
              label: "S\xE4hk\xF6posti",
              fieldProps: contact_person_email
            })
          )
        ),
        _react2.default.createElement(
          "h2",
          { className: "h4 form-title" },
          this.renderSoilTypeTitle()
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Select2.default, {
              placeholder: "Valitse tyyppi",
              fieldProps: soil_type_id,
              options: this.props.soilTypes
            })
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(
              "div",
              { className: "row" },
              _react2.default.createElement(
                "div",
                { className: "col col-xs-8" },
                _react2.default.createElement(_Input2.default, {
                  id: "soil_amount",
                  type: "text",
                  label: "Paino",
                  fieldProps: soil_amount
                })
              ),
              _react2.default.createElement(
                "div",
                { className: "col-xs-4" },
                _react2.default.createElement(
                  "span",
                  { className: "ad-form-soil-amount-label" },
                  "tonnia",
                  " ",
                  _react2.default.createElement("i", {
                    className: "icon-mp-info",
                    "data-toggle": "tooltip",
                    title: "Maa-ainekset eiv\xE4t ole painoltaan samanlaisia. Voit kuitenkin muuttaa kuutiot tonneiksi kertomalla kuutiom\xE4\xE4r\xE4n 1,6:lla."
                  })
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-xs-12" },
            _react2.default.createElement(_Input2.default, {
              id: "soil_description",
              type: "text",
              label: "Maa-aineksen tarkennus",
              fieldProps: soil_description,
              max: 150
            })
          )
        ),
        _react2.default.createElement(
          "h2",
          { className: "h4 form-title" },
          this.getDatePickerLabel(),
          " "
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-3" },
            _react2.default.createElement(
              "label",
              { htmlFor: "delivery_start_date" },
              "alkupvm"
            ),
            " ",
            _react2.default.createElement("br", null),
            _react2.default.createElement(_reactDatepicker2.default, {
              fixedHeight: true,
              id: "delivery_start_date",
              dateFormat: "D.M.YYYY",
              locale: "fi_FI",
              minDate: (0, _moment2.default)(),
              selected: this.state.deliveryStartDate,
              onChange: this.handleDeliveryStartDateChange,
              placeholderText: "Valitse p\xE4iv\xE4m\xE4\xE4r\xE4",
              fieldProps: delivery_start_date
            })
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-3" },
            _react2.default.createElement(
              "label",
              { htmlFor: "delivery_end_date" },
              "loppu_pvm"
            ),
            " ",
            _react2.default.createElement("br", null),
            _react2.default.createElement(_reactDatepicker2.default, {
              fixedHeight: true,
              id: "delivery_end_date",
              dateFormat: "D.M.YYYY",
              locale: "fi_FI",
              minDate: this.state.deliveryStartDate,
              selected: this.state.deliveryEndDate,
              onChange: this.handleDeliveryEndDateChange,
              placeholderText: "Valitse p\xE4iv\xE4m\xE4\xE4r\xE4",
              fieldProps: delivery_end_date
            })
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Input2.default, {
              id: "delivery_time",
              type: "text",
              label: "Lis\xE4tiedot",
              fieldProps: delivery_time
            })
          )
        ),
        _react2.default.createElement(
          "h2",
          { className: "h4 form-title" },
          "Muuta"
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(
              "div",
              { className: "row" },
              _react2.default.createElement(
                "div",
                { className: "col col-xs-8" },
                _react2.default.createElement(_Input2.default, {
                  id: "price",
                  type: "text",
                  label: "Hinta (sis. alv)",
                  subLabel: "(vapaaehtoinen)",
                  fieldProps: price
                })
              ),
              _react2.default.createElement(
                "div",
                { className: "col-xs-4" },
                "\u20AC / t"
              )
            )
          ),
          _react2.default.createElement("div", { className: "col col-sm-6" })
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(
              "label",
              { htmlFor: "validity_duration" },
              "Ilmoituksen viimeinen n\xE4ytt\xF6p\xE4iv\xE4:"
            ),
            " ",
            _react2.default.createElement("br", null),
            _react2.default.createElement(_reactDatepicker2.default, {
              fixedHeight: true,
              id: "validity_duration",
              dateFormat: "D.M.YYYY",
              locale: "fi_FI",
              minDate: (0, _moment2.default)(),
              selected: this.state.startDate,
              onChange: this.handleStartDateChange,
              placeholderText: "Valitse p\xE4iv\xE4m\xE4\xE4r\xE4",
              fieldProps: validity_duration
            })
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Input2.default, {
              id: "notes",
              type: "text",
              label: "Muuta huomioitavaa",
              fieldProps: notes
            })
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          editing ? _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Checkbox2.default, {
              id: "activated",
              label: "Aktiivinen ilmoitus",
              fieldProps: activated
            })
          ) : "",
          isProjectAd ? "" : _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(
              _Checkbox2.default,
              {
                id: "transfer_request",
                label: "Haluan vastaanottaa kuljetustarjouspyynt\xF6j\xE4",
                fieldProps: transfer_request
              },
              _react2.default.createElement(
                "p",
                { className: "small" },
                "T\xE4t\xE4 ilmoitusta koskevat kuljetustarjouspyynn\xF6t l\xE4htev\xE4t kaikille k\xE4ytt\xE4jille, jotka ovat profiilinsa asetuksista valinneet vastaanottavansa kuljetustarjouspyynt\xF6j\xE4. Pyynn\xF6t tulevat profiilin s\xE4hk\xF6postiosoitteeseen."
              )
            )
          )
        ),
        isProjectAd ? _react2.default.createElement(_SubmitButton2.default, {
          text: editing ? "Päivitä" : "Jatka",
          submitting: this.props.loading
        }) : _react2.default.createElement(_SubmitButton2.default, {
          text: editing ? "Päivitä" : "Ilmoita",
          submitting: this.props.loading
        }),
        isProjectAd ? _react2.default.createElement(
          "div",
          { className: "row" },
          this.showProjektLink()
        ) : ""
      );
    }
  }, {
    key: "showProjektLink",
    value: function showProjektLink() {
      var project = this.props.project;

      if (project) {
        var projectUrl = "/projekti/" + project.project_id;
        return _react2.default.createElement(
          "div",
          { className: "col col-xs-12" },
          _react2.default.createElement(
            "p",
            null,
            _react2.default.createElement(
              _reactRouter.Link,
              { to: projectUrl },
              "Siirry projekin sivulle"
            ),
            " "
          )
        );
      }
    }
  }, {
    key: "addContactInfo",
    value: function addContactInfo(event) {
      event.preventDefault();

      var _props2 = this.props,
          project = _props2.project,
          user = _props2.user,
          company = _props2.company,
          isProjectAd = _props2.isProjectAd,
          validUntil = _props2.validUntil,
          resetForm = _props2.resetForm,
          editing = _props2.editing;
      var _props$fields3 = this.props.fields,
          contact_person_name = _props$fields3.contact_person_name,
          contact_person_phone = _props$fields3.contact_person_phone,
          contact_person_email = _props$fields3.contact_person_email;


      contact_person_name.onChange(user.first_name + " " + user.last_name);
      contact_person_phone.onChange(user.phone);
      contact_person_email.onChange(user.email);
    }
  }, {
    key: "clearContactInfo",
    value: function clearContactInfo(event) {
      event.preventDefault();

      var _props$fields4 = this.props.fields,
          contact_person_name = _props$fields4.contact_person_name,
          contact_person_phone = _props$fields4.contact_person_phone,
          contact_person_email = _props$fields4.contact_person_email;


      contact_person_name.onChange("");
      contact_person_phone.onChange("");
      contact_person_email.onChange("");
    }
  }, {
    key: "renderHeaderSection",
    value: function renderHeaderSection() {
      var _props3 = this.props,
          ad_type = _props3.fields.ad_type,
          editing = _props3.editing;

      if (editing) {
        var text = ad_type.value === "supplierAd" ? "tarjoajailmoitusta" : "vastaanottajailmoitusta";
        return _react2.default.createElement(
          "div",
          { className: "col col-xs-12" },
          _react2.default.createElement(
            "h1",
            { className: "h3 editing-title-js" },
            "Muokkaa ",
            text,
            ":"
          )
        );
      }

      return _react2.default.createElement(
        "div",
        { className: "col col-sm-6" },
        _react2.default.createElement(_RadioGroup2.default, {
          title: "Valitse millaisen ilmoituksen haluat tehd\xE4.",
          name: "ad_type",
          fieldProps: ad_type,
          options: [{
            id: "supplierAd",
            value: "supplierAd",
            title: "Tarjotaan maa-ainesta"
          }, {
            id: "receiverAd",
            value: "receiverAd",
            title: "Vastaanotetaan maa-ainesta"
          }]
        })
      );
    }
  }, {
    key: "renderAdVisibilitySection",
    value: function renderAdVisibilitySection() {
      var _props4 = this.props,
          ad_visibility = _props4.fields.ad_visibility,
          editing = _props4.editing;

      var isProjectAd = this.props.isProjectAd;

      if (isProjectAd) {
        return _react2.default.createElement("div", { className: "col col-sm-6" });
      }

      var _props5 = this.props,
          user = _props5.user,
          company = _props5.company;

      if (editing) {
        return _react2.default.createElement(
          "div",
          { className: "col col-sm-6" },
          _react2.default.createElement(_RadioGroup2.default, {
            title: " Ilmoituksen n\xE4kyvyys:",
            name: "ad_visibility",
            fieldProps: ad_visibility,
            options: [{
              id: "public_Ad",
              value: "public_Ad",
              title: "Ilmoitus näkyy verkkosivulla"
            }, {
              id: "private_Ad",
              value: "private_Ad",
              title: "Yrityksen sisäinen ilmoitus"
            }]
          })
        );
      }

      if (!user || !company) {
        return _react2.default.createElement("div", { className: "col col-sm-6" });
      }

      // default
      return _react2.default.createElement(
        "div",
        { className: "col col-sm-6" },
        _react2.default.createElement(_RadioGroup2.default, {
          title: " Ilmoituksen n\xE4kyvyys:",
          name: "ad_visibility",
          fieldProps: ad_visibility,
          options: [{
            id: "public_Ad",
            value: "public_Ad",
            title: "Ilmoitus näkyy verkkosivulla"
          }, {
            id: "private_Ad",
            value: "private_Ad",
            title: company.name + ":n sisäinen ilmoitus"
          }]
        })
      );
    } // end renderAdVisibility

  }, {
    key: "renderSoilTypeTitle",
    value: function renderSoilTypeTitle() {
      var ad_type = this.props.fields.ad_type;

      return ad_type.value === "supplierAd" ? "Tarjottava materiaali" : "Vastaanotettava materiaali";
    }
  }, {
    key: "handleMarkerDrag",
    value: function handleMarkerDrag(coordinates) {
      var _props$fields5 = this.props.fields,
          latitude = _props$fields5.latitude,
          longitude = _props$fields5.longitude;

      latitude.onChange(coordinates.latitude);
      longitude.onChange(coordinates.longitude);
    }
  }, {
    key: "getUTCTime",
    value: function getUTCTime(weeksFromNow) {
      return (0, _moment2.default)().add(weeksFromNow, "weeks").set("second", 0).set("minute", 0).format();
    }
  }, {
    key: "handleStartDateChange",
    value: function handleStartDateChange(date) {
      this.setState({
        startDate: date
      });
    }
  }, {
    key: "handleDeliveryStartDateChange",
    value: function handleDeliveryStartDateChange(date) {
      this.setState({
        deliveryStartDate: date
      });
    }
  }, {
    key: "handleDeliveryEndDateChange",
    value: function handleDeliveryEndDateChange(date) {
      this.setState({
        deliveryEndDate: date
      });
    }
  }, {
    key: "getDatePickerLabel",
    value: function getDatePickerLabel() {
      var ad_type = this.props.fields.ad_type;

      return ad_type.value === "supplierAd" ? "Toimituksen ajankohta" : "Vastaanoton ajankohta";
    }
  }]);
  return AdForm;
}(_react.Component), _class.propTypes = {
  fields: _react.PropTypes.object.isRequired,
  handleSubmit: _react.PropTypes.func.isRequired,
  soilTypes: _react.PropTypes.array.isRequired,
  submitAd: _react.PropTypes.func.isRequired,
  user: _react.PropTypes.object,
  company: _react.PropTypes.object,
  loading: _react.PropTypes.bool.isRequired,
  editing: _react.PropTypes.bool.isRequired,
  project: _react.PropTypes.object,
  routeParams: _react.PropTypes.object.isRequired,
  isProjectAd: _react.PropTypes.bool.isRequired,
  validUntil: _react.PropTypes.String,
  deliveryStartDate: _react.PropTypes.String,
  deliveryEndDate: _react.PropTypes.String
}, _temp);
exports.default = AdForm;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ads/AdForm.js
 ** module id = 474
 ** module chunks = 0
 **/